import { useLanguage } from '../../context/LanguageContext';
import { GOOGLE_REVIEW_URL } from '../../utils/schema';
import { trackReviewClick } from '../../utils/tracking';

export default function ReviewPrompt({ placement = 'page' }) {
  const { t } = useLanguage();

  return (
    <section className="text-center px-4 py-6 bg-gray-50 rounded-2xl">
      <h2 className="text-lg font-bold text-black m-0 mb-1">{t('rentPage.reviewTitle')}</h2>
      <p className="text-[13px] text-gray-500 m-0 mb-4">{t('rentPage.reviewText')}</p>
      <a
        href={GOOGLE_REVIEW_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackReviewClick(placement)}
        className="inline-flex items-center gap-2 bg-white border border-gray-300 rounded-xl px-5 py-3 text-[14px] font-bold text-black no-underline hover:shadow-md transition-shadow"
      >
        <span className="text-dewalt" aria-hidden="true">★★★★★</span>
        {t('rentPage.reviewBtn')}
      </a>
    </section>
  );
}
